import React from 'react';
import classes from './error.module.sass';

const Error = ({children}) => {
    return (
        <div className={classes.error}>
            {children}
        </div>
    );
};

export default Error;